import { SET_DETAIL } from "constants/ActionTypes";

export default (state, action) => {
  switch (action.type) {
    case SET_DETAIL:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
